// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const storage = {
  getItem: (key: string) => {
    // console.log('Getting auth item:', key, localStorage.getItem(key));
    return localStorage.getItem(key);
  },
  setItem: (key: string, value: string) => {
    console.log('Setting auth item:', key, value);
    localStorage.setItem(key, value);
  },
  removeItem: (key: string) => {
    console.log('Removing auth item:', key);
    localStorage.removeItem(key);
  }
};

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage,
    storageKey: 'supabase.auth.token',
    flowType: 'pkce',
    debug: false
  }
});


